module.exports = __webpack_public_path__ + "img/w5.a4a334ef.svg";